import React, { useState } from "react";
import axios from "axios";
import { Box, TextField, Button } from "@mui/material";
import theme from "./Theme";

const CommentForm = ({ placeId, userId, authToken, refetchPlaceData }) => {
  const getApiBaseUrl = () => {
    // Always use production backend (onrender)
    return import.meta.env.VITE_ENVPROD || 'https://activitynavigator-backend.onrender.com';
  };
  const apiBaseUrl = getApiBaseUrl();
  const [commentText, setCommentText] = useState("");

  const handleCommentSubmit = async () => {
    try {
      await axios.post(
        `${apiBaseUrl}/api/users/${userId}/comment`,
        {
          placeId: placeId,
          comment: commentText,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setCommentText("");
      refetchPlaceData();
    } catch (error) {
      console.error("Error adding comment:", error);
    }
  };

  return (
    <Box mt={2}>
      <TextField
        label="Add a comment"
        variant="outlined"
        fullWidth
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleCommentSubmit}
        style={{ marginTop: "1rem" }}
      >
        Add Comment
      </Button>
    </Box>
  );
};

export default CommentForm;
